import AutoComplete from './helpers/autocomplete';
import * as attendee from './pastors-path/classRegistrant';
import { analyticsInit } from './helpers/analyticsInit.js';

// Takes an array of fields and returns false if any field value is empty
const allFieldsFilled = (fields) =>
  Array.isArray(fields) && fields.every((field) => field.value !== '');

const initPastorPathLeadForm = () => {
  const autoCompleteConfig = {
    elem: document.querySelector('[id$=church-name]'),
    resultType: ['church', 'place_of_worship'],
    formMappings: {
      street_number: 'organizationAddress',
      route: 'organizationAddress',
      locality: 'organizationCity',
      administrative_area_level_1: 'organizationState',
      postal_code: 'organizationPostalCode',
      phone: 'organizationPhone',
      name: 'organizationName'
    }
  };

  AutoComplete(autoCompleteConfig);

  const form = document.querySelector('.PastorPath-form');
  const roleFormFieldEl = document.querySelector('.PastorPath-churchRole');
  const nonPastorTextEl = document.querySelector('.PastorPath-nonPastor');
  const button = document.querySelector('.PastorPath-button');
  const smsOptInFieldEl = document.querySelector('.PastorPath-smsOptIn');
  const churchNameInputEl = document.querySelector("[id$='church-name']");
  const churchRoleSelectEl = document.querySelector("[id$='business-role']");
  const customerNameInputEl = document.querySelector("[id$='customer-name']");
  const customerEmailInputEl = document.querySelector("[id$='customer-email']");
  const customerPhoneInputEl = document.querySelector("[id$='customer-phone']");
  const customerFirstNameEl = document.querySelector(
    "[id$='customerFirstName']"
  );
  const customerLastNameEl = document.querySelector("[id$='customerLastName']");
  const signupTrackIdEl = document.querySelector("[id$='signupTrackId']");
  const smsOptInEl = document.querySelector("[id$='sms-opt-in']");
  const smsPhoneNumberEl = document.querySelector("[id$='smsPhoneNumber']");

  const reqFields = [
    churchNameInputEl,
    churchRoleSelectEl,
    customerNameInputEl,
    customerEmailInputEl,
    customerPhoneInputEl
  ];

  if (smsOptInFieldEl) {
    reqFields.push(smsOptInFieldEl);
  }

  churchRoleSelectEl.addEventListener('change', (e) => {
    if (e.target.value === 'Non-pastor') {
      roleFormFieldEl.classList.add('is-invalid');
      nonPastorTextEl.removeAttribute('hidden');
      button.disabled = true;
    } else {
      roleFormFieldEl.classList.remove('is-invalid');
      nonPastorTextEl.setAttribute('hidden', true);
      button.disabled = false;
    }
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (
      allFieldsFilled(reqFields) &&
      customerNameInputEl.value.split(' ').length > 1
    ) {
      button.disabled = true;
      button.innerText = 'Scheduling... Please wait.';
      attendee.classRegistrant.populate(form);
      customerFirstNameEl.value = attendee.classRegistrant.firstName;
      customerLastNameEl.value = attendee.classRegistrant.lastName;
      if (smsOptInEl) {
        smsOptInEl.value = attendee.classRegistrant.smsOptIn;
      }
      signupTrackIdEl.value = attendee.classRegistrant.signupTrackId;
      smsPhoneNumberEl.value = `+1${attendee.classRegistrant.phone.replace(
        /[-.()\s]/g,
        ''
      )}`;

      form.dispatchEvent(
        new Event('triggerRecaptcha', { cancelable: true, bubbles: true })
      );
    }
  });

  button.disabled = false;
};

analyticsInit();
initPastorPathLeadForm();
